import { createAxiosCancelable } from '@hmhco/core-network/src/axiosHelpers';
import requestHelper from '@hmhco/core-network/src/utils/requestHelper';
import { getIdentifiedPlatformConfig } from '@hmhco/login-config';

const getOptionsUrl = (clientId, orgRefId) =>
  `/${clientId}/${orgRefId}/login-options`;

export const useLoginOptions = pactConfig => {
  const { client, cancel, cancelToken, isCancel } = createAxiosCancelable({
    includeAuth: false,
  });
  const request = requestHelper({
    client,
    cancelToken,
    isCancel,
    baseURL: getIdentifiedPlatformConfig().EDSLoginUrl,
    pactConfig,
  });
  return {
    getLoginOptions: (clientId, orgRefId) =>
      request.get(getOptionsUrl(clientId, orgRefId)),
    cancel,
  };
};

export default useLoginOptions;
